import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { convertToGMT8, dateFormat, pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import { DownFill } from "antd-mobile-icons";
import { CalendarPicker, CalendarPickerViewRef } from "antd-mobile";
import dayjs from "dayjs";

const CalendarTime: React.ForwardRefRenderFunction<
	any,
	{ onSubmit: () => void; daysToSubtract?: number }
> = ({ onSubmit, daysToSubtract = 30 }, ref) => {
	const classes = useStyles();
	const elementTimeRef = useRef<CalendarPickerViewRef>(null);
	const calendarRef = useRef<any>(null);
	const defaultRange: [Date, Date] = [
		dayjs().subtract(daysToSubtract, "day").startOf("day").toDate(),
		dayjs().toDate(),
	];
	const [minDate] = useState(dayjs().subtract(5, "month")); // 六个月
	const [maxDate] = useState(dayjs().add(0, "day"));

	const [visible, setVisible] = useState(false);
	const [startTime, setStartTime] = useState(defaultRange[0]);
	const [endTime, setEndTime] = useState(defaultRange[1]);

	useImperativeHandle(ref, () => ({
		startTime: dateFormat(
			convertToGMT8(startTime, 8).getTime(),
			"YYYY-MM-dd hh:mm:ss"
		),
		endTime: dateFormat(
			convertToGMT8(endTime, 8).getTime(),
			"YYYY-MM-dd hh:mm:ss"
		),
	}));

	useEffect(() => {
		if (visible) {
			setTimeout(() => {
				elementTimeRef.current && elementTimeRef.current.jumpToToday();
				const element = document.querySelector(
					".adm-calendar-picker-view-cell-selected-begin"
				);
				if (element) {
					element.scrollIntoView();
				}
			}, 100);
		}
	}, [visible]);

	useEffect(() => {
		const newDefaultRange: [Date, Date] = [
			dayjs().subtract(daysToSubtract, "day").startOf("day").toDate(),
			dayjs().toDate(),
		];
		setStartTime(newDefaultRange[0]);
		setEndTime(newDefaultRange[1]);
	}, [daysToSubtract]);

	return (
		<div ref={calendarRef}>
			<div className={classes.timeboxWrap}>
				<div onClick={() => setVisible(true)} className="time">
					<span>
						{dateFormat(
							convertToGMT8(startTime, 9).getTime(),
							"YYYY-MM-dd hh:mm"
						)}
					</span>
					<DownFill color="#5E71B7" fontSize={10} />
				</div>
				<div onClick={() => setVisible(true)} className="time">
					<span>
						{dateFormat(
							convertToGMT8(endTime, 9).getTime(),
							"YYYY-MM-dd hh:mm"
						)}
					</span>
					<DownFill color="#5E71B7" fontSize={10} />
				</div>
			</div>
			<CalendarPicker
				visible={visible}
				defaultValue={defaultRange}
				selectionMode="range"
				onClose={() => setVisible(false)}
				onMaskClick={() => setVisible(false)}
				onChange={(val) => {
					if (val) {
						const st = new Date(
							`${val[0].getFullYear()}/${
								val[0].getMonth() + 1
							}/${val[0].getDate()} 00:00:00 GMT+09:00`
						);
						const et = new Date(
							`${val[1].getFullYear()}/${
								val[1].getMonth() + 1
							}/${val[1].getDate()} 23:59:59 GMT+09:00`
						);
						setStartTime(st);
						setEndTime(et);
					}
				}}
				onConfirm={() => {
					onSubmit();
				}}
				min={minDate.toDate()}
				max={maxDate.toDate()}
				renderBottom={undefined}
				className={classes.calendarPickerWrap}
				style={{ color: "#FFFFFF" }}
				ref={elementTimeRef}
			/>
		</div>
	);
};

export default CalendarTime;
const useStyles = createUseStyles({
	timeboxWrap: {
		display: "flex",
		justifyContent: "space-between",
		padding: {
			top: pxToRem(10),
			bottom: pxToRem(10),
		},
		"& .time": {
			display: "flex",
			alignItems: "center",
			padding: {
				left: pxToRem(17),
				right: pxToRem(15),
			},
			width: pxToRem(160),
			height: pxToRem(36),
			borderRadius: pxToRem(40),
			border: "1px solid #2F3A62",
			"& span": {
				flex: 1,
				overflow: "hidden",
				fontSize: pxToRem(12),
				fontWeight: "400",
				color: "#FFFFFF",
			},
		},
	},
	calendarPickerWrap: {
		"--color": "#4675FF",
		"--adm-color-light": "#868FA8",
		"--adm-color-text": "#FFFFFF",
		"--adm-color-box": "#1E212A",
		"--adm-color-border": "transparent",
		"--adm-color-primary": "#4C66C7",
		background: "#1E212A", //"linear-gradient(156deg, #181B24 5.2%, #232C48 97.46%)",
	},
});
